export const CONSENT_MATCH = "/consents/:id"

export const CONSENT_STATUS_DONE = "done"

export const SUBSCRIPTION_CONSENT_TYPE = "SUBSCRIPTION"
